import {
  getFileTypeName,
  getTypesAll,
} from './document-types'

import {
  getStateText,
  getStateColor,
  getStateIcon,
  getStateList,
} from './document-states'

import {
  truncateText,
  isTextTruncated,
  formatFileSize,
  getCategoryList,
} from './format-utils'

import {
  normalizeText,
  normalizeFileName,
  normalizeFile,
} from './filename-utils'

import { dateHelper } from '@/utils/dateHelper'

// Tarih formatlama fonksiyonu
const formatDate = (dateString) => {
  if (!dateString) return '-'
  try {
    return dateHelper.formatLocalized(dateString, 'medium', { type: 'datetime' })
  } catch (error) {
    console.error('Tarih formatlanırken hata oluştu:', error)
    return dateString
  }
}

export {
  // Document types
  getFileTypeName,
  getTypesAll,

  // Document states
  getStateText,
  getStateColor,
  getStateIcon,
  getStateList,

  // Format utilities
  truncateText,
  isTextTruncated,
  formatFileSize,
  getCategoryList,
  formatDate,

  // Filename utilities
  normalizeText,
  normalizeFileName,
  normalizeFile,
}